import AddCustomerForms from "@/app/components/routes/auth_routes/CustomerProfile/AddCustomer/AddCustomerForms";
import React from "react";
import { ICustomerAddPageProps } from "./interface";

const CustomerAddPage: React.FC<ICustomerAddPageProps> = (_props) => {
  return (
    <div className="w-full h-full mb-20 bg-white px-2 py-3">
      <AddCustomerForms addressLayout="SINGLE" forUpdate={false} layoutFor="BOTH" />
    </div>
  );
};

export default CustomerAddPage;
